import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export default {
  props: {
    title: "",
    banKeys: "",
    isNumber: {
      default: function _default() {
        return false;
      },
      type: Boolean
    },
    style: {
      default: function _default() {
        return {
          width: "100%"
        };
      },
      type: Object
    },
    isShowHeader: {
      default: function _default() {
        return true;
      },
      type: Boolean
    },
    tableData: {
      default: function _default() {
        return [];
      },
      type: Array
    },
    header: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    repeatList: {
      default: function _default() {
        return [];
      },
      type: Array
    }
  },
  data: function data() {
    return {
      isBlur: true,
      maxheight: "500px"
    };
  },
  watch: {},
  mounted: function mounted() {
    var height = document.body.clientHeight;

    if (height <= 700) {
      this.maxheight = "300px";
    }
  },
  methods: {
    keyup: function keyup(ev, row, col) {
      this.keyupTo(ev, row, col, this.tableData.length, Object.getOwnPropertyNames(this.header).length - 1);
    },
    keyupTo: function keyupTo(ev, row, col, rowCount, colCount) {
      var _this = this;

      // 替代 switch 的优雅写法
      var actions = {
        ArrowUp: function ArrowUp() {
          row--;
          if (row < 0) row = rowCount - 1;
        },
        ArrowDown: function ArrowDown() {
          row++;
          if (row >= rowCount) row = 0;
        },
        ArrowLeft: function ArrowLeft() {
          col--;

          if (col <= 0) {
            if (_this.banKeys && _this.banKeys.length !== 0) {
              col = 1;
            } else {
              col = 0;
            }
          }
        },
        ArrowRight: function ArrowRight() {
          if (_this.banKeys && _this.banKeys.length == 3) {
            return false;
          }

          col++;

          if (col >= colCount) {
            col = colCount;
          }
        }
      };
      var action = actions[ev.key];
      this.inputDom = this.$refs["spanr" + row + "c" + col][0];
      this.txtDom = this.$refs["txtr" + row + "c" + col][0];

      if (action !== undefined) {
        action.call(); // 用 nextTick 避免 input 还没渲染出来

        this.$nextTick(function () {
          _this.$refs["spanr" + row + "c" + col][0].style.display = "block";

          _this.$refs["r" + row + "c" + col][0].focus();
        });
      }
    },
    getRowKey: function getRowKey(row) {
      /** 检查row.id是否有重复的缓存对象 */
      if (!this.checkRepeatObj) {
        this.checkRepeatObj = {};
      }

      if (row) {
        if (row.id) {
          if (this.checkRepeatObj[row.id]) {
            if (!row._secondId) {
              row._secondId = Math.random() + "";
            }
            /** 方便根据key重用元素 */


            return row._secondId;
          } else {
            this.checkRepeatObj[row.id] = 1;
            return row.id;
          }
        }

        if (!row._secondId) {
          row._secondId = Math.random() + "";
        }

        return row._secondId;
      } else {
        return Math.random() + "";
      }
    },
    // 添加明细原因 row 当前行 column 当前列
    tabClick: function tabClick(row, column, cell, event) {
      var inputDom = cell.querySelector(".inputSpan");
      var txtDom = cell.querySelector(".content");

      if (!inputDom || !txtDom) {
        return false;
      }

      this.inputDom = inputDom;
      this.txtDom = txtDom;
      inputDom.style.display = "block";
      txtDom.style.display = "none";
      this.$nextTick(function () {
        inputDom.querySelector("input").focus();
      });
    },
    // 失去焦点初始化
    inputBlur: function inputBlur(item, key) {
      if (!this.isBlur) return false;

      if (item[key] && this.isNumber) {
        var val = item[key];

        if (isNaN(val)) {
          $gb.tip("请输入数值", "warning");
          item[key] = "";
        } else {
          item[key] = parseFloat(val);
        }

        if (key == "lowerLimit" || key == "upperLimit") {
          if (item.lowerLimit && item.upperLimit) {
            if (item.lowerLimit >= item.upperLimit) {
              $gb.tip("\u60A8\u8F93\u5165\u7684".concat(item.element, "\u542B\u91CF\u4E0B\u9650\u9AD8\u4E8E\u4E0A\u9650"), "warning");
            }
          }
        }

        if (key === "content") {
          if (item.lowerLimit && item.upperLimit) {
            if (item.content >= item.upperLimit) {
              this.txtDom.style.color = "#ef5350";
            } else if (item.content <= item.lowerLimit) {
              this.txtDom.style.color = "#42a5f5";
            } else {
              this.txtDom.style.color = "#606266";
            }
          }
        }

        if (key === "outerLowerLimit" || key === "outerupperLimit") {
          if (item.outerLowerLimit && item.outerupperLimit) {
            if (item.outerLowerLimit >= item.outerupperLimit) {
              $gb.tip("\u60A8\u8F93\u5165\u7684".concat(item.element, "\u5143\u7D20\u5916\u63A7\u4E0B\u9650\u9AD8\u4E8E\u4E0A\u9650"), "warning");
            }
          }
        }

        if (key === "innerLowerLimit" || key === "innerUpperLimit") {
          if (item.innerLowerLimit && item.innerUpperLimit) {
            if (item.innerLowerLimit >= item.innerUpperLimit) {
              $gb.tip("\u60A8\u8F93\u5165\u7684".concat(item.element, "\u5143\u7D20\u5185\u63A7\u4E0B\u9650\u9AD8\u4E8E\u4E0A\u9650"), "warning");
            }
          }
        }
      }

      if (this.inputDom) {
        this.inputDom.style.display = "none";
      }

      if (this.txtDom) {
        this.txtDom.style.display = "block";
      }

      this.txtDom = null;
      this.inputDom = null;
      this.$emit("inputBlur", item);
    },
    input: function input(val) {
      if (val === "") {
        this.isBlur = false;
      } else {
        this.isBlur = true;
      }
    },
    isBan: function isBan(row, key) {
      if (this.banKeys && this.banKeys.length !== 0) {
        if (this.banKeys.includes(key)) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
};